webpackJsonp([54],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	
	/* global require, ga, _hmt */
	var browser;
	
	__webpack_require__(10);
	
	__webpack_require__(16);
	
	__webpack_require__(19);
	
	__webpack_require__(3);
	
	__webpack_require__(23);
	
	__webpack_require__(146);
	
	__webpack_require__(1);
	
	__webpack_require__(5);
	
	__webpack_require__(4);
	
	__webpack_require__(7);
	
	__webpack_require__(21);
	
	__webpack_require__(2);
	
	__webpack_require__(26);
	
	browser = {
	  isIE8: !!navigator.userAgent.match(/MSIE 8.0/),
	  isIE9: !!navigator.userAgent.match(/MSIE 9.0/)
	};
	
	(function() {
	
	  /*
	    * 轮播图
	   */
	  var $agreement, $btn, $cunt, $form, $mobile, $truename;
	  $('#slider').flexslider({
	    animation: 'fade',
	    directionNav: false,
	    animationDuration: 800
	  });
	
	  /*
	   * 顶部报名
	   */
	  $form = $('#appointment form');
	  $truename = $form.find('input[name="truename"]');
	  $mobile = $form.find('input[name="mobile"]');
	  $btn = $form.find('button[type="submit"]');
	  $agreement = $form.find('[name = agreement]');
	  $cunt = $('#cunt');
	  browser = {
	    isIE8: !!navigator.userAgent.match(/MSIE 8.0/),
	    isIE9: !!navigator.userAgent.match(/MSIE 9.0/)
	  };
	  $mobile.on('focus', function() {
	    var $me;
	    $me = $(this);
	    return $btn.addClass('hover');
	  });
	  $mobile.on('blur', function() {
	    var $me;
	    $me = $(this);
	    return $btn.removeClass('hover');
	  });
	  $form.validate({
	    errorPlacement: function(error, elem) {
	      if (browser.isIE8) {
	        alert(error.html());
	      }
	      return swal({
	        type: 'error',
	        title: error.html(),
	        allowOutsideClick: true,
	        confirmButtonText: '确定',
	        confirmButtonColor: '#2F86F9'
	      });
	    },
	    submitHandler: function(form) {
	      var phoneNumber, userId;
	      if (!browser.isIE8) {
	        phoneNumber = form.elements.mobile.value.trim();
	        userId = "MOBI" + phoneNumber;
	      }
	      return $(form).ajaxSubmit({
	        dataType: 'json',
	        error: function() {
	          if (browser.isIE8) {
	            alert('对不起！出错了,请稍后重试！');
	          }
	          return swal({
	            type: 'error',
	            title: '对不起！出错了,请稍后重试！',
	            allowOutsideClick: true,
	            confirmButtonText: '确定',
	            confirmButtonColor: '#2F86F9'
	          });
	        },
	        success: function(res) {
	          if (res.status === 'success') {
	            $cunt.html(parseInt($cunt.html()) + 1);
	            return swal({
	              customClass: 'alert-success',
	              title: '<img class="form_success" src="' + $('#alertImg').attr('src') + '" alt="">',
	              confirmButtonText: '返  回',
	              confirmButtonColor: '#3b9bff',
	              allowOutsideClick: true,
	              html: true
	            });
	          } else {
	            if (browser.isIE8) {
	              alert(res.msg[0].info);
	            }
	            return swal({
	              type: 'error',
	              title: res.msg[0].info,
	              allowOutsideClick: true,
	              confirmButtonText: '确定',
	              confirmButtonColor: '#2F86F9'
	            });
	          }
	        },
	        complete: function() {
	          return $btn.removeAttr('disabled');
	        }
	      });
	    }
	  });
	  if ($agreement.length) {
	    $agreement.rules('add', {
	      required: true,
	      messages: {
	        required: '请勾选已阅读并同意积木家的用户协议'
	      }
	    });
	  }
	  $mobile.rules('add', {
	    required: true,
	    mobileNum: true,
	    messages: {
	      required: '请输入手机号码',
	      mobileNum: '请输入正确手机号码'
	    }
	  });
	  return $truename.rules('add', {
	    required: true,
	    messages: {
	      required: '请输入姓名'
	    }
	  });
	})();
	
	(function() {
	  var $height, $mfdh, $rightFloat;
	  $rightFloat = $('.right-float');
	  $mfdh = $('.mfdh');
	  $height = $("body").height() - ($(window).height() - 136);
	  return $(window).scroll(function() {
	    var scrollTop;
	    $mfdh.hide();
	    scrollTop = $(window).scrollTop();
	    if ($height <= scrollTop) {
	
	    } else if (480 <= scrollTop) {
	      return $rightFloat.stop().animate({
	        right: 30
	      }, 50);
	    } else {
	      return $rightFloat.stop().animate({
	        right: -70
	      }, 50);
	    }
	  });
	})();


/***/ },

/***/ 146:
3

});


/** WEBPACK FOOTER **
 ** taste.b67f5d197628fd3386d2.js
 **/